import { render, staticRenderFns } from "./ServerLED.vue?vue&type=template&id=52a11d72&"
import script from "./ServerLED.vue?vue&type=script&lang=js&"
export * from "./ServerLED.vue?vue&type=script&lang=js&"
import style0 from "./ServerLED.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports